import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function More(): React.ReactElement {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.8301 0.320312H2.16992C1.24727 0.320312 0.5 1.07222 0.5 1.99023V12.0098C0.5 12.9332 1.25276 13.6797 2.16992 13.6797H17.8301C18.745 13.6797 19.5 12.9364 19.5 12.0098V1.99023C19.5 1.07386 18.7557 0.320312 17.8301 0.320312ZM17.5962 1.43359C17.255 1.77296 11.3835 7.61353 11.1808 7.81518C10.8654 8.13061 10.4461 8.30428 10 8.30428C9.55395 8.30428 9.13461 8.13057 8.81814 7.81414C8.6818 7.67851 2.87511 1.90243 2.40379 1.43359H17.5962ZM1.61328 11.7832V2.21753L6.42407 7.00297L1.61328 11.7832ZM2.40449 12.5664L7.21338 7.78809L8.03198 8.60238C8.55767 9.12807 9.25659 9.41756 10 9.41756C10.7434 9.41756 11.4423 9.12807 11.967 8.60342L12.7866 7.78809L17.5955 12.5664H2.40449ZM18.3867 11.7832L13.5759 7.00297L18.3867 2.21753V11.7832Z" />
    </svg>
  );
}
